"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var _InternalPanelDoNotUseOrYouWillBeFired = _antd.message._InternalPanelDoNotUseOrYouWillBeFired;
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement(_InternalPanelDoNotUseOrYouWillBeFired, {
    type: 'success',
    content: '这是一条成功消息，会主动消失'
  });
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorSuccess'],
  key: 'success'
};
var _default = exports.default = componentDemo;